import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const MyCompanyView = observer(() => {
  const navigate = useNavigate()

  // Redirect to settings page - this route is deprecated
  useEffect(() => {
    navigate('/settings#bedrijf', { replace: true })
  }, [navigate])

  return null
})
